import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import copyToClipboard from "copy-to-clipboard";
import {message} from "antd";
import {SubjectActionTypes} from "../../../AppLocals/Course";
import {IoCopyOutline} from "react-icons/io5";
import {GoDotFill} from "react-icons/go";

export const renderSubject = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    return (
        <Translate key={index}>
            {(t) => (
                <div className="p-3 flex flex-col gap-1 border border-color-50 shadow-md rounded-lg hover:scale-xs custom-item-render relative">
                    <h2
                        onClick={() => {handleAction(SubjectActionTypes.SUBJECT_READ, item)}}
                        className="font-bold text-lg text-color-000 hover:text-primary cursor-pointer">
                        {item?.title}
                    </h2>
                    {renderIf(
                        item?.subject_idcode,
                        <div className="flex items-center gap-2">
                            <div className="flex items-center gap-3">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-sm text-color-400 italic">
                                    {`${t('subject code')}: `}
                                </span>
                            </div>
                            <span
                                onClick={() => {
                                    copyToClipboard(item?.subject_idcode)
                                    message.info(t('copied'))
                                }}
                                className="flex-1 font-semibold text-color-100 hover:text-color-000 cursor-pointer tracking-wide">
                                {`#${item?.subject_idcode}`}
                                <IoCopyOutline size={12} className="ml-1"/>
                            </span>
                        </div>
                    )}
                    {renderIf(
                        item.description,
                        <div className="text-color-200 tracking-wider max-lines-2">
                            {item?.description}
                        </div>
                    )}
                    <div className="mt-auto flex justify-end">
                        <div className="w-fit px-3 border border-blue-400 bg-blue-50 rounded-full font-medium text-xs text-blue-500 italic">
                            {`${item?.number_of_sessions} ${t('sessions')}`}
                            {renderIf(
                                item?.number_of_credits > 0,
                                ` - ${item?.number_of_credits} ${t('credits')}`
                            )}
                        </div>
                    </div>
                    <div className="absolute right-5 top-5 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}
